// /utils/GlobalEventEmitter file

import Vue from 'vue'
export const GlobalEventEmitter = new Vue()
